import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import Constants from "../common/Constants";
import { ICaseLawDocument } from "../model/CaseLawDocument";
import CaseLawDocumentMapper from "../service/CaseLawDocumentMapper";
import CaseLawDocumentParamMapper from "../service/CaseLawDocumentParamMapper";
export default class GetCaseLawDocumentInteractor {
  private resource: FindResourceEntryInteractor<ICaseLawDocument>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(id: number) {
    return this.resource.execute(
      `${Constants.endpointBasePath}`,
      CaseLawDocumentMapper,
      CaseLawDocumentParamMapper,
      id
    );
  }
}
